import Vue from "vue";
import {APIHOST} from "@/settings/server";
import $store from "../store";
import axios from "axios";

class UnitService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }

    get() {
        return Vue.axios.get(`${APIHOST}/api/unit`, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            params: {
                clientType: $store.getters.appActiveClient.id
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }
}

export default new UnitService()